
import { Component, EventEmitter, OnInit, Output, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import {  forkJoin, throwError } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { User } from 'src/models/user';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { APICustomdashboardService } from 'src/services/api-services/api-custom-dashboard';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { HelperService } from 'src/services/helperService';
import { dashboardDateService } from '../../../services/dashboardDateService.service';
import { TranslateService } from '@ngx-translate/core';
import { DashboardOverly, GraphBooking } from 'src/services/api-services/api-interfaces/api-OverlayDashboardBooking.interface';

@Component({
    selector: 'app-overall-summary',
    templateUrl: './overall-summary.component.html',
    styleUrls: ['./overall-summary.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OverallSummaryComponent implements OnInit {
  isExpanded: boolean = false;
  @Output() onToggleExpandCollapseChart: EventEmitter<boolean> = new EventEmitter();
 
  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showLegend: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisTicks: string[] = [];
  animations: boolean = true;
  showYAxisLabel: boolean = true;
  legendPosition: LegendPosition = LegendPosition.Below;
  monthName=''
  colorScheme: Color = {
    name: 'overallSummaryChartScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#B7CD00', '#00233A', '#16BAE7',
      '#9E61A4', '#F2E500', '#DC7700',
      '#DC9E00', '#0FC9B3', '#7B7A7C']
  };
  graphDashboard$: Observable<GraphBooking[]> = new Observable<GraphBooking[]>()
  FilterDashboard$:Observable<DashboardOverly> = new Observable<DashboardOverly>()
  graphAndFilters$ = new Observable<[GraphBooking[], DashboardOverly]> ()
  dateToday:Date = new Date();
  initialDate:string = this.getStartOfWeek()
  finalDate:string = this.getEndOfWeek()
  initialDate2:string = this.getStartOfWeek2()
  finalDate2:string = this.getEndOfWeek2()
  getfilterdisable:boolean =false
  userProfile?: User;
  text_tittle!:string
  selectDropDown = "CurrentMonth"
  sucursalId:number=0
  marcaId:number=0
  ToggleAdvisor:boolean=false;
  monthNumber!:number;
  dropDownList:string[]=[]

  constructor( 
    public schedulerService: APISchedulerService, 
    public WorkshopService: APIWorkshopService, 
    public customScheduleService: APICustomScheduleService, 
    public helperService: HelperService, 
    public ServiceAdvisorApi: APIServiceAdvisorService, 
    public brandsService: APIBrandsService,
    public DashboardService: APICustomdashboardService,
    public date:dashboardDateService,
    private translate: TranslateService
  ) {
    this.date.currentMessage.subscribe(monthName => { this.monthName = monthName })
   }

  ngOnInit(): void {
    this.Grafic()
    this.graphAndFilters$ = forkJoin([
      this.graphDashboard$,
      this.FilterDashboard$
    ]);
  }
  // Method Grafic and Filter Dashboard 
  Grafic() {
    switch (this.helperService.user.role.roleId) {

      case 1:
        this.text_tittle = "AppointmentsByTypeOfAdvisorService"
        if(!this.getfilterdisable){ 
          this.FilterDashboard$ = this.DashboardService?.getDashboardFilters(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.advisorId);
          this.dropDownList = ['CurrentWeek','CurrentMonth']  
          this.getfilterdisable = true}
        this.getDashboardGrafic(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.advisorId) 
      break;
      
      case 2:
        this.text_tittle = "AppointmentsByAdvisor/TypeOfService"
        if(!this.getfilterdisable){ 
          this.FilterDashboard$ = this.DashboardService?.getDashboardFilters(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.workshopId);
          this.dropDownList = ['CurrentDay','CurrentWeek','NextWeek','CurrentMonth'] 
          this.getfilterdisable = true}
        this.getDashboardGrafic(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.workshopId)
      break;

      case 3:
        this.text_tittle = "AppointmentsByTypeOfService"
        if(!this.getfilterdisable){ 
          this.FilterDashboard$ = this.DashboardService?.getDashboardFilters(this.helperService.user.role.roleId, this.helperService.user.countryId);
          this.dropDownList = ['CurrentDay','CurrentWeek','NextWeek','CurrentMonth']
          this.getfilterdisable =true
        }
        this.getDashboardGrafic(this.helperService.user.role.roleId, this.helperService.user.countryId, 0)
      break;

      case 4:
        
        this.text_tittle = "AppointmentsByTypeOfService"
        if(!this.getfilterdisable){ 
          this.FilterDashboard$ = this.DashboardService?.getDashboardFilters(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.retailId);
          this.dropDownList = ['CurrentDay','CurrentWeek','NextWeek','CurrentMonth']  
          this.getfilterdisable = true;
        }
        this.getDashboardGrafic(this.helperService.user.role.roleId, this.helperService.user.countryId,this.helperService.user.retailId)
      break; 

      case 5:
        this.text_tittle = "AppointmentsByTypeOfService"
        if(!this.getfilterdisable){
          this.FilterDashboard$ = this.DashboardService?.getDashboardFilters(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.userid);
          this.dropDownList = ['CurrentDay','CurrentWeek','NextWeek','CurrentMonth']
          this.getfilterdisable =true
        }
         this.getDashboardGrafic(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.userid)
      break;

      case 6:
        this.text_tittle = "AppointmentsByAdvisor/TypeOfService"
        if(!this.getfilterdisable){ 
          this.FilterDashboard$ = this.DashboardService?.getDashboardFilters(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.workshopId);
          this.dropDownList = ['CurrentDay','CurrentWeek','NextWeek','CurrentMonth'] 
          this.getfilterdisable = true}
        this.getDashboardGrafic(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.workshopId)
      break;

    }
  }
 
  getDashboardGrafic(RoleId:number, CountryId:number, EspecificRole:number)
   {
    let activeAdvisor = 0 
    if(this.ToggleAdvisor) activeAdvisor = 1
    
    switch (this.selectDropDown) {
      case 'CurrentDay':      
        this.graphDashboard$ = this.DashboardService.getDashboardGraph(RoleId,CountryId, 
          this.dateToday.getFullYear()+"-"+(this.dateToday.getMonth()+1)+"-"+this.dateToday.getDate(), 
          this.dateToday.getFullYear()+"-"+(this.dateToday.getMonth()+1)+"-"+this.dateToday.getDate(), 
          EspecificRole,this.marcaId,this.sucursalId,0,activeAdvisor).pipe(
            map((xAxisTicks)=>{
           xAxisTicks.forEach((value)=>{
            value.name=this.translate.instant(value.name)
            value.series.forEach((series)=>{
            series.name= this.translate.instant(series.name)
          })
         })
           return xAxisTicks
          }))
      break;
      case 'CurrentWeek':
        this.graphDashboard$ = this.DashboardService.getDashboardGraph(RoleId,CountryId, 
          this.initialDate, this.finalDate, EspecificRole,this.marcaId,this.sucursalId,0,activeAdvisor).pipe(
            map((xAxisTicks)=>{
           xAxisTicks.forEach((value)=>{
          if (!this.ToggleAdvisor) {
            value.name=this.translate.instant(value.name.slice(0, 2))
          }
            value.name=this.translate.instant(value.name)
            value.series.forEach((series)=>{
            series.name= this.translate.instant(series.name)
          })
         })
           return xAxisTicks
          }))
      break;
      case 'NextWeek':
        this.graphDashboard$ = this.DashboardService.getDashboardGraph(RoleId,CountryId,
          this.initialDate2, this.finalDate2, EspecificRole,this.marcaId,this.sucursalId,0,activeAdvisor).pipe(
            map((xAxisTicks)=>{
            xAxisTicks.forEach((value)=>{
          if (!this.ToggleAdvisor) {
            value.name=this.translate.instant(value.name.slice(0, 2))
          }
            value.name=this.translate.instant(value.name)
            value.series.forEach((series)=>{
            series.name= this.translate.instant(series.name)
          })
         })
           return xAxisTicks
          }))
      break;
      case 'CurrentMonth':
       

        this.graphDashboard$ = this.DashboardService.getDashboardGraph(RoleId,CountryId, 
          this.dateToday.getFullYear()+"-"+(this.dateToday.getMonth()+1)+"-"+ 1,
          this.dateToday.getFullYear()+"-"+ (this.dateToday.getMonth()+1)+"-"+ 
         this.getLastDayOfMonth(this.dateToday.getFullYear(), this.dateToday.getMonth()),  EspecificRole,this.marcaId,this.sucursalId,1,activeAdvisor).pipe(
          map((xAxisTicks)=>{
          xAxisTicks.forEach((value)=>{
          value.name=this.translate.instant(value.name)
          value.series.forEach((series,index)=>{
          series.name= this.translate.instant(series.name)
      })
     })
       return xAxisTicks
      }), catchError((error: any) => {
                     // Handle validation error here
                     if(error.status === 401){
                      this.helperService.logoutToken()
                    }
                   console.error('Validation Error:', error);
                   // Rethrow the error to propagate it downstream
                   return throwError(error);
                   }))
      break;
    }
  }
  // Method collapse calendar and enlarge Grafic
  expandCollapseChart(toExpand: boolean): void {
    if(toExpand)
      document.getElementsByClassName('legend-labels')[0].classList.add('legend-expanded');
    else
      document.getElementsByClassName('legend-labels')[0].classList.remove('legend-expanded');
    this.isExpanded = toExpand;
    this.onToggleExpandCollapseChart.emit(toExpand);}

  // Method the dates and formats
getLastDayOfMonth(year, month): number {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  firstDay.setHours(0, 0, 0, 0);
  lastDay.setHours(0, 0, 0, 0);

  const diff = (lastDay.getTime() - firstDay.getTime()) / 86400000 + 1;

  return Math.round(diff);
}

  getStartOfWeek() {
    const today = new Date(); 
    const dayOfWeek = today.getDay(); 
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    return new Date(today.setDate(diff)).toISOString().split('T')[0];  }

    getEndOfWeek() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diff = today.getDate() + (6 - dayOfWeek) + (dayOfWeek === 0 ? -6 : 1);
    return new Date(today.setDate(diff)).toISOString().split('T')[0]; }

  getStartOfWeek2() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1) + 7; // add 7 days to get next week
    return new Date(today.setDate(diff)).toISOString().split('T')[0];}

  getEndOfWeek2() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diff = today.getDate() + (6 - dayOfWeek) + (dayOfWeek === 0 ? -6 : 1) + 7; // add 7 days to get next week
    return new Date(today.setDate(diff)).toISOString().split('T')[0];}

  getStartOfWeekMonthWeek(month:number, weekNumber:number):string {
    const today = new Date();
    const year = today.getFullYear();
    const startDate = new Date(year, month - 1, 1); // Month is zero-based
    const dayOfWeek = startDate.getDay();
    const diff = (7 * (weekNumber - 1)) + (dayOfWeek === 0 ? -6 : 1) - startDate.getDate();
    const startOfWeek = new Date(year, month - 1, startDate.getDate() + diff);
    return startOfWeek.toISOString().split('T')[0]; }

}
